// Affected-user lists appended to the proposal PDF (capped per list; the CSV export in the drill-down has the full list).
import { authApi } from "./auth";

export const APPENDIX_CAP = 200;
const GAP_LABEL = { entra_p1: "Entra ID P1", entra_p2: "Entra ID P2", intune_p1: "Intune Plan 1" };
const lineName = (l) => l.sku?.name || (l.unlicensed ? "Unlicensed users" : l.from_plan);
const FINDING_PARAMS = { admins_p2: { filter: "admins_nop2" }, nomfa_p1: { filter: "nomfa" }, legacy_p1: { filter: "legacy" } };

/** Which lists to include for a plan + scan summary. */
export const appendixLists = (plan, summary) => {
  const lists = [];
  plan.lines
    .filter((l) => l.changed && l.remediation)
    .forEach((l) => {
      const r = l.remediation;
      const sku = l.sku?.sku_id || "__unlicensed__";
      const target = [l.targetBase?.name, ...l.addonUnits.map((a) => a.name)].filter(Boolean).join(" + ");
      lists.push({
        id: `move-${l.from_sku}`,
        title: `${lineName(l)} → ${target}`,
        description: r.finding ? `Security fix: ${r.label}.` : `Closes a license gap: these users are targeted by Conditional Access policies but miss ${r.missing.map((m) => GAP_LABEL[m] || m).join(" + ")}.`,
        params: r.finding ? { ...FINDING_PARAMS[r.finding], sku } : { filter: "gaps", sku, missing: r.missing.join(",") },
      });
    });
  if (summary.gaps?.users_with_gaps) lists.push({ id: "gaps", title: "All users with a license gap", description: "Users targeted by an active Conditional Access policy whose license does not include the required Entra ID / Intune entitlement.", params: { filter: "gaps" } });
  const sec = summary.security;
  if (sec?.admin_counts?.no_mfa) lists.push({ id: "admins_nomfa", title: "Privileged users without MFA registered", description: "Admin role holders with no MFA method registered.", params: { filter: "admins_nomfa" } });
  if (sec?.admin_counts?.no_p2) lists.push({ id: "admins_nop2", title: "Privileged users without Entra ID P2", description: "Admin role holders whose licenses do not include Entra ID P2 (PIM, Identity Protection).", params: { filter: "admins_nop2" } });
  if (sec?.legacy_auth?.users) lists.push({ id: "legacy", title: `Legacy-authentication users (last ${sec.legacy_auth.window_days} days)`, description: "Users who signed in with basic-auth protocols that cannot enforce MFA.", params: { filter: "legacy" } });
  return lists;
};

export const fetchAppendix = (scanId, lists) =>
  Promise.all(
    lists.map(async (l) => {
      const d = await authApi.scans.users(scanId, { ...l.params, size: APPENDIX_CAP });
      return { ...l, users: d.items, total: d.total };
    })
  );
